const PROMOB_PREFIX = "PROMOB";
const SINGLE_REQUEST_SALE_ID = 1111111;

const getProductDescription = (productItem: any) =>
  String(productItem?.product?.description ?? productItem?.description ?? "")
    .trim()
    .toUpperCase();

const getFieldReport = (event: any) => event?.fieldReport ?? event;

export const getAssemblyLineType = (products: any[] = []) => {
  const hasPromobProduct = products
    .map(getProductDescription)
    .some((description: string) => description.startsWith(PROMOB_PREFIX));

  return hasPromobProduct ? "Linha Planejada" : "Linha Pronta";
};

const hasPartsRequest = (fieldReport: any) =>
  Boolean(fieldReport?.PartsRequest?.length);

const isTechnicalAssistance = (fieldReport: any) =>
  Boolean(fieldReport?.idAssistTec) ||
  String(fieldReport?.title ?? "")
    .trim()
    .toUpperCase() === "S.A.A.";

const isSingleRequest = (fieldReport: any) =>
  Number(fieldReport?.saleId) === SINGLE_REQUEST_SALE_ID &&
  String(fieldReport?.title ?? "")
    .trim()
    .toUpperCase() === "S.A.";

export const getAssemblyTimelineEventBadge = (event: any) => {
  const fieldReport = getFieldReport(event);
  const products = fieldReport?.products ?? [];
  const productDescriptions: string[] = products.map(getProductDescription);
  const hasPromobProduct = productDescriptions.some((description: string) =>
    description.startsWith(PROMOB_PREFIX)
  );
  const hasNonPromobProduct = productDescriptions.some(
    (description: string) => description && !description.startsWith(PROMOB_PREFIX)
  );
  const hasMixedProducts = hasPromobProduct && hasNonPromobProduct;
  const needsYellowAttention =
    hasPartsRequest(fieldReport) ||
    hasMixedProducts ||
    isTechnicalAssistance(fieldReport);

  if (needsYellowAttention) {
    return {
      label: "Assistência",
      className: hasPromobProduct
        ? "assembly-event-promob assembly-event-yellow-border"
        : "assembly-event-parts-request",
      backgroundColor: "#faad14",
      color: "#1f1f1f",
    };
  }

  if (hasPromobProduct) {
    return {
      label: "Linha Planejada",
      className: "assembly-event-promob",
      backgroundColor: "#722ed1",
      color: "#ffffff",
    };
  }

  if (isSingleRequest(fieldReport)) {
    return {
      label: "Avulsa",
      className: "assembly-event-single-request",
      backgroundColor: "#1890ff",
      color: "#ffffff",
    };
  }

  return {
    label: "Linha pronta",
    className: "assembly-event-ready-line",
    backgroundColor: "#01c558",
    color: "#ffffff",
  };
};

export const getAssemblyTimelineEventClassName = (event: any) => {
  const isInProgress = Boolean(event?.inProgress ?? event?.fieldReport?.inProgress);
  const baseClassName = getAssemblyTimelineEventBadge(event).className;

  return isInProgress
    ? `${baseClassName} assembly-event-in-progress`
    : baseClassName;
};
